import { render, staticRenderFns } from "./camera-view.vue?vue&type=template&id=f4ac726a&scoped=true&"
import script from "./camera-view.vue?vue&type=script&lang=js&"
export * from "./camera-view.vue?vue&type=script&lang=js&"
import style0 from "./camera-view.vue?vue&type=style&index=0&id=f4ac726a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4ac726a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VImg,VRow,VSpacer})
